import styled from 'styled-components';
import { COLORS, FONTS } from '@ertelecom/ui-react/assets/js/constants';
import StyledButton from '@ertelecom/ui-react/components/buttons/styledButton/styledButton';

const width = {
    small: 'min-width: 768px',
    medium: 'min-width: 1024px',
    large: 'min-width: 1366px',
    extraLarge: 'min-width: 1920px',
};

const padding = {
    default: '16px',
    small: '24px',
    large: '40px',
    extraLarge: '52px',
};

export const Container = styled.div`
    background: ${COLORS.lightGrey};
    border-radius: 4px;
    width: 100%;
    flex-wrap: nowrap;       
    margin-bottom: 36px;
    
    flex-direction: column;
    padding: ${padding['default']};
    
    @media(${width['small']}) {
        flex-direction: row;
        padding: ${padding['small']};
    }
    
    @media(${width['large']}) {
        padding: ${padding['large']};
    }
    
    @media(${width['extraLarge']}) {
        padding: ${padding['extraLarge']};
    }
`;

export const ContainerPicture = styled.div`
    flex-wrap: nowrap;
    padding-bottom: 12px; 
    
    padding-right: ${padding['default']};
    
    @media(${width['small']}) {
        padding-right: ${padding['small']};
        padding-bottom: 0;
    }
    
    @media(${width['large']}) {
        padding-right: ${padding['large']};
    }
    
    @media(${width['extraLarge']}) {
        padding-right: ${padding['extraLarge']};
    }
`;

export const ContainerContent = styled.div`
    flex: 1;
    flex-wrap: nowrap;
    flex-direction: column;
    
    @media(${width['medium']}) {
        flex-direction: row;
    }
`;

export const ContainerText = styled.div`
    flex: 2;
    display: block;
    flex-wrap: nowrap;
    
    padding-right: ${padding['default']};
    
    @media(${width['small']}) {
        padding-right: ${padding['small']};
    }
    
    @media(${width['large']}) {
        padding-right: ${padding['large']};
    }
    
    @media(${width['extraLarge']}) {
        padding-right: ${padding['extraLarge']};
    }  
`;

export const ContainerButtonSpeedUp = styled.div`
    flex: 1;
    flex-direction: column;
    height: fit-content;
    flex-wrap: nowrap;
    align-items: flex-start;
    @media(${width['medium']}) {
        align-items: flex-start;
    }  
`;

export const ContainerButton = styled.div`
    flex: 1;
    align-items: flex-start;
    @media(${width['medium']}) {
        align-items: center;
    }  
`;

export const TextConnected = styled.div`
    ${FONTS.S};
    padding-bottom: 10px;
    
    @media(${width['small']}) {
        ${FONTS.S};
    }
    
    @media(${width['large']}) {
        ${FONTS.L};
    }
    
    @media(${width['extraLarge']}) {
        ${FONTS.XXL};
    } 
`;

export const TextLeasing = styled.div`
    color: ${COLORS.darkGrey};
    ${FONTS.XXS};
    padding-bottom: 16px;
    
    @media(${width['small']}) {
        ${FONTS.S};
        padding-bottom: 24px;      
    }
    
    @media(${width['medium']}) {
        padding-bottom: 0;
    }
`;

export const Button = styled(StyledButton)`
    white-space: nowrap;
    max-width: 227px;
`;

export const Pic = styled.img`
    height: 48px;
    width: 48px;
        
    @media(${width['small']}) {
        height: 64px;
        width: 64px;
    }
    
    @media(${width['medium']}) {
        height: 80px;
        width: 80px;
    }
`;

export const SpeedBonusGrayText = styled.div`
    color: ${COLORS.darkGrey};
    ${FONTS.XS};
`;
